import { useRef, useState } from 'react';
import { useEncounter } from '@/contexts/encounter-context';
import { PageContainer } from '@/components/containers/page-container';
import { GradientFormTitle } from '@/components/containers/gradient-form-title';
import { useMediaQuery } from '@/hooks/use-media-query';
import { SaveProgressButton } from '@/components/navigation/save-progress-button';
import { VisitTitleButtons } from '@/components/navigation/visit-title-buttons';
import { Navigate } from '@/util/react-router-dom';
import { SelectedPharmacy } from '@/components/encounter/pharmacy/selected-pharmacy';
import { PharmacyList } from '@/components/encounter/pharmacy/pharmacy-list';
import { VisitNavigation } from '@/components/navigation/visit-navigation';
import { useVisitNavigation } from '@/contexts/visit-navigation-context';
import { useTranslation } from '@/contexts/i18n-context';

const translationBase = 'visit.pharmacySelection';

export function PharmacySelectionPage() {
  const { encounter } = useEncounter();
  const isMobile = useMediaQuery('--screen-md');
  const [editPharmacy, setEditPharmacy] = useState(false);
  const { editMode } = useVisitNavigation();

  const pharmacyListRef = useRef<HTMLDivElement>(null);

  const { t } = useTranslation();

  const onPageChange = () => {
    if (pharmacyListRef.current) {
      pharmacyListRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  // If we try to access this page and there is no preferred
  // pharmacy type it needs to redirect us to the previous page
  if (!encounter.preferredPharmacyType) {
    return <Navigate to={`/visit/${encounter.id}/pharmacy-type-selection`} replace />;
  }

  return (
    <PageContainer ref={pharmacyListRef}>
      {!isMobile && <VisitTitleButtons />}
      <GradientFormTitle>
        {isMobile && <VisitTitleButtons />}
        <VisitNavigation />
        <h1 className="h3">{t(`${translationBase}.formTitle.title`)}</h1>
        <p>{t(`${translationBase}.formTitle.description`)}</p>
        {isMobile && <SaveProgressButton />}
      </GradientFormTitle>
      {!editMode && !editPharmacy && encounter.preferredPharmacyId ? (
        <SelectedPharmacy
          pharmacyId={encounter.preferredPharmacyId}
          onEdit={() => setEditPharmacy(true)}
        />
      ) : (
        <PharmacyList onPageChange={onPageChange} />
      )}
    </PageContainer>
  );
}
